// Commodity catalogue for detail pages & SEO
export const PRODUCTS = {
  grains: {
    slug: "grains",
    name: "Grains & Pulses",
    tagline: "Basmati rice, wheat, corn, chickpeas, lentils, mung.",
    seo: "Export-grade grains & pulses from India — basmati rice, wheat, maize, chickpeas, lentils and mung beans. Traceable origin, lab-tested, container-ready shipments from Aadiyogis EXIM Traders.",
    heroImg: "https://images.unsplash.com/photo-1586201375761-83865001e31c?crop=entropy&cs=srgb&fm=jpg&q=85",
    intro:
      "The backbone of our portfolio. We source directly from India's most productive belts, clean and grade to buyer specification, and dispatch in bulk or retail-ready packs. Every consignment is moisture-controlled and traceable to its origin mill.",
    origin: "Punjab, Haryana, Madhya Pradesh & Andhra Pradesh, India",
    packaging: ["PP / jute bags 25kg & 50kg", "Non-woven vacuum packs 1–20kg", "Bulk in 20ft / 40ft containers"],
    gallery: [
      "https://images.unsplash.com/photo-1723475158232-819e29803f4d?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1643622357625-c013987d90e7?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1686820740687-426a7b9b2043?crop=entropy&cs=srgb&fm=jpg&q=85",
    ],
    items: [
      { name: "Basmati Rice (1121 / 1509)", grades: "Steam, Sella, Raw, Golden Sella", specs: "Avg. grain 8.30–8.40mm, moisture ≤ 13%, broken ≤ 1%" },
      { name: "Non-Basmati Rice", grades: "IR64, Sona Masoori, PR11", specs: "5% / 25% broken, sortex clean, moisture ≤ 14%" },
      { name: "Wheat & Maize", grades: "Milling wheat, yellow corn", specs: "Protein 11–12%, admixture ≤ 2%, aflatoxin controlled" },
      { name: "Pulses", grades: "Chickpea (Kabuli/Desi), Lentils, Mung, Toor", specs: "Machine-cleaned, uniform sizing 6–9mm, purity ≥ 99%" },
    ],
  },
  spices: {
    slug: "spices",
    name: "Spices",
    tagline: "Turmeric, red chili, cardamom, cumin, black pepper.",
    seo: "Premium Indian spices for export — turmeric, red chilli, cumin, cardamom and black pepper. High-curcumin, high-ASTA colour, ISO & phytosanitary certified lots from Aadiyogis EXIM Traders.",
    heroImg: "https://images.unsplash.com/photo-1486548730767-5c679e8eda6b?crop=entropy&cs=srgb&fm=jpg&q=85",
    intro:
      "India is the spice capital of the world, and we bring its finest to your market. Our spices are selected for colour, aroma and active-compound strength, then tested for pesticide residue, ASTA colour and microbial safety before every shipment.",
    origin: "Andhra Pradesh, Telangana, Kerala & Rajasthan, India",
    packaging: ["Food-grade PP bags 10–50kg", "Vacuum & nitrogen-flushed packs", "Retail pouches, private-label ready"],
    gallery: [
      "https://images.pexels.com/photos/30319219/pexels-photo-30319219.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
      "https://images.unsplash.com/photo-1532336414038-cf19250c5757?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1681817009639-9103dc524813?crop=entropy&cs=srgb&fm=jpg&q=85",
    ],
    items: [
      { name: "Turmeric", grades: "Finger, Bulb, Polished, Powder", specs: "Curcumin 3–5%, moisture ≤ 10%, no artificial colour" },
      { name: "Red Chilli", grades: "Teja S17, 334, Byadgi", specs: "ASTA colour 30–160, SHU on request, stemless options" },
      { name: "Cumin & Coriander", grades: "Singapore 99%, Europe 99%", specs: "Purity ≥ 99%, machine-cleaned, low ash" },
      { name: "Cardamom & Black Pepper", grades: "8mm+ green cardamom, MG1 pepper", specs: "Bold, aromatic, moisture ≤ 12%" },
    ],
  },
  oilseeds: {
    slug: "oilseeds",
    name: "Oilseeds & Edible Oils",
    tagline: "Sesame, groundnut, mustard, sunflower, castor.",
    seo: "Oilseeds and edible oils for export — hulled sesame, groundnut kernels, mustard, sunflower and castor. High oil content, sortex-clean, food-safe packing from Aadiyogis EXIM Traders.",
    heroImg: "https://images.unsplash.com/photo-1594999791332-48843eebd9d9?crop=entropy&cs=srgb&fm=jpg&q=85",
    intro:
      "From whole seed to pressed oil, we serve crushers, processors and food brands alike. Our oilseeds are graded for oil content and purity, while our oils are sourced from trusted mills with full documentation.",
    origin: "Gujarat, Rajasthan & Andhra Pradesh, India",
    packaging: ["25kg / 50kg PP bags", "Flexi-tanks & drums for oils", "Bulk container loads"],
    gallery: [
      "https://images.unsplash.com/photo-1616543206920-645d23587ebe?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1676619357571-b4f086f81299?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1690200271569-8af83ea13411?crop=entropy&cs=srgb&fm=jpg&q=85",
    ],
    items: [
      { name: "Sesame Seeds", grades: "Natural, Hulled, Black", specs: "Purity 99.95%, oil content ≥ 48%, sortex clean" },
      { name: "Groundnut (Peanut)", grades: "Java, Bold, Blanched", specs: "Counts 38/42–80/90, aflatoxin ≤ 4ppb, moisture ≤ 8%" },
      { name: "Mustard & Sunflower", grades: "Black/Yellow mustard, confectionery sunflower", specs: "Oil content ≥ 38%, admixture ≤ 1%" },
      { name: "Edible Oils", grades: "Groundnut, Sunflower, Mustard, Castor", specs: "Refined / cold-pressed, FFA controlled, certificates provided" },
    ],
  },
  fresh: {
    slug: "fresh",
    name: "Fresh Produce",
    tagline: "Mangoes, pomegranates, onions, garlic, ginger.",
    seo: "Fresh Indian produce for export — Alphonso & Kesar mangoes, pomegranates, onions, garlic and ginger. Cold-chain managed, farm-fresh, globally certified by Aadiyogis EXIM Traders.",
    heroImg: "https://images.unsplash.com/photo-1601493700631-2b16ec4b4716?crop=entropy&cs=srgb&fm=jpg&q=85",
    intro:
      "Perishables demand precision. We manage harvest timing, pre-cooling and cold-chain logistics so your produce arrives fresh, firm and ready for shelf — backed by phytosanitary and residue certifications.",
    origin: "Maharashtra, Gujarat, Karnataka & Andhra Pradesh, India",
    packaging: ["Ventilated corrugated cartons", "Mesh bags for onion/garlic", "Reefer containers, temperature logged"],
    gallery: [
      "https://images.unsplash.com/photo-1601767770428-265b2c67780c?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1615485925600-97237c4fc1ec?crop=entropy&cs=srgb&fm=jpg&q=85",
      "https://images.unsplash.com/photo-1541344999736-83eca272f6fc?crop=entropy&cs=srgb&fm=jpg&q=85",
    ],
    items: [
      { name: "Mangoes", grades: "Alphonso, Kesar, Banganapalli, Totapuri", specs: "Brix 14–20, hand-picked, hot-water treated" },
      { name: "Pomegranates", grades: "Bhagwa, Ganesh", specs: "Size 200–350g, deep-red arils, brix ≥ 15" },
      { name: "Onions", grades: "Red, Pink, White", specs: "Size 40–70mm, cured, low pungency options" },
      { name: "Garlic & Ginger", grades: "White garlic, fresh ginger", specs: "Size 40mm+, firm bulbs, moisture controlled" },
    ],
  },
};

export const PRODUCT_LIST = Object.values(PRODUCTS);
